<template>
    <div v-if="inspections.length" class="table-responsive">
        <table class="table table-hover table-vcenter">
            <thead>
                <tr>
                    <th style="width: 64px;"></th>
                    <th>Inspection ID</th>
                    <th v-if="showInspector">Forester Name</th>
                    <th>Contact Name</th>
                    <th>Region</th>
                    <th>Created</th>
                    <th style="width: 100px;">Status</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="inspection in inspections" v-on:click="onRowClick($event.target, inspection)" v-bind:data-id="inspection.id">
                    <td style="width: 64px;"><i class="icon-doc text-muted"></i></td>
                    <td>{{ inspection.id }}</td>
                    <td v-if="showInspector && inspection.inspector.user.contact.first_name">{{ inspection.inspector.user.contact.first_name }} {{ inspection.inspector.user.contact.last_name }}</td>
                    <td v-else-if="showInspector"><span class="text-muted">N/A</span></td>
                    <td v-if="inspection.contact.first_name">{{ inspection.contact.first_name }} {{ inspection.contact.last_name }}</td>
                    <td v-else><span class="text-muted">N/A</span></td>
                    <td v-if="inspection.region">{{ inspection.region.abbr }}</td>
                    <td v-else><span class="text-muted">N/A</span></td>
                    <td>{{ inspection.created_at.date | moment('YYYY/M/D - HH:mm') }}</td>
                    <td class="status-badge-cell">
                        <inspection-status-badge :inspection="inspection">
                        </inspection-status-badge>
                    </td>
                    <td v-if="showDelete" class="text-right">
                        <button class="btn btn-xs btn-danger" type="button" @click="onDeleteInspectionClick(inspection)">
                            <i class="fa fa-times push-5-r"></i>Delete
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

    </div>

    <div v-else class="row">
        <div class="col-md-6 col-md-offset-3">
            <div class="text-center text-muted" style="padding-top: 60px;">
                <p><i class="icon-ghost" style="font-size: 100px;"></i></p>
                <h3 style="margin-bottom: 20px;">No inspections found.</h3>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vel nulla ac risus aliquam pellentesque. Quisque posuere nunc augue, nec posuere quam elementum quis.</p>
            </div>
        </div>
    </div>


    
</template>

<script>
    export default {
        components: {
            inspectionStatusBadge: require('./inspection-status-badge.vue'),
        },
        props: {
            inspections: { type: Array, default: [] },
            inspectionsMeta: { type: Object, default: () => { return { total:0, page:0 }; } },
            columns: { type: Array, default: [] },
        },
        computed: {
            showInspector: function() {
                return this.columns.indexOf('inspector') >= 0;
            },
            showDelete: function() {
                return this.columns.indexOf('delete') >= 0;
            },
        },
        methods: {
            onRowClick(target, inspection) {
                if(target.type != "button" && (!target.parentNode || target.parentNode.type != "button")) { // hack for 'times' on the button
                    this.$router.push('/inspections/'+inspection.id);
                }
            },
            onDeleteInspectionClick(inspectionId) {
                this.$emit("deleteInspection", [inspectionId]);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// inspection-list.vue?77c6e388